import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";

export function OperatorSelect({ operations, value, onChange }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        aria-label="Comparison operator"
        className="tw:w-16 tw:bg-white tw:dark:bg-background"
      >
        <SelectValue placeholder="Op">
          {op => operations.find(o => o.value === op)?.symbol}
        </SelectValue>
      </SelectTrigger>
      <SelectContent alignItemWithTrigger={false} className="tw:w-52">
        <SelectGroup>
          {operations.map(op => (
            <SelectItem key={op.value} value={op.value}>
              <span className="tw:inline-block tw:w-5 tw:text-center tw:font-medium">
                {op.symbol}
              </span>
              {op.text}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
